const tagsView = {
  state: {
    visitedViews: [],
    cachedViews: [],
    isRouterAlive: true
  },
  mutations: {
    CHANGE_ROUTER_AVLIVE: (state, view) => {
      state.isRouterAlive = view
    },
    ADD_VISITED_VIEWS: (state, view) => {

      let viewIndex
      if (state.visitedViews.some(v => v.name === view.name)){
        viewIndex = state.visitedViews.findIndex(element => element.name === view.name)
        Object.assign(state.visitedViews[viewIndex], {
          query: view.query
        })
        sessionStorage.setItem('STATE_NAME',JSON.stringify(state.visitedViews[viewIndex]))
      } else {
        let stateVal = Object.assign({}, view, {
          title: view.meta.title || '无标题'
        })
        if(view.fullPath.indexOf('?') == -1 && !!sessionStorage.getItem('STATE_NAME')){
          viewIndex = state.visitedViews.findIndex(element => element.name === JSON.parse(sessionStorage.getItem('STATE_NAME')).name)
          state.visitedViews.splice(viewIndex+1,0,stateVal)
        }else {
          state.visitedViews.push(stateVal)
        }
        sessionStorage.removeItem('STATE_NAME')
          return true
      }
    },
    ADD_VISITED_LIST: (state, list) => {
        state.visitedViews = list.map(e => Object.assign({isIframe: true}, e))
    
    },
    ADD_CACHED_LIST: (state, list) => {
      state.cachedViews = list.map(e => Object.assign({isIframe: true}, e))
  },
    DEL_VISITED_VIEW: (state, view) => {
      for (const [i, v] of state.visitedViews.entries()) {
        if (v.path === view.path) {
          state.visitedViews.splice(i, 1)
          break
        }
      }
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    ADD_CACHED_VIEW: (state, view) => {
      if (state.cachedViews.includes(view.name)) return
      if (!view.meta.noCache) {
        state.cachedViews.push(view.name)
      }
    },
    DEL_OTHERS_VIEWS: (state, view) => {
      state.visitedViews = [view]
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews = state.cachedViews.slice(index, i + 1)
          break
        }
      }
    },
    DEL_ALL_VIEWS: (state) => {
      state.visitedViews =[]
      state.cachedViews = []
    },
    DEL_CACHED_VIEW: (state, view) => {
      for (const i of state.cachedViews) {
        if (i === view.name) {
          const index = state.cachedViews.indexOf(i)
          state.cachedViews.splice(index, 1)
          break
        }
      }
    },
    DEL_NEXT_ALL_VIEWS:(state, view)=> {
      let index = state.visitedViews.findIndex(e =>  e.name === view.name)
      let len = state.cachedViews.length
      state.visitedViews.splice(index, 1)
    } 
  },
  actions: {
    changeRouterAlive({ commit }, view) {
      commit('CHANGE_ROUTER_AVLIVE', view)
    },
    addViews({ dispatch }, view) {
      dispatch('addCachedView', view)
      dispatch('addVisitedView', view)
    },
    addList({ dispatch }, list) {
      dispatch('addCachedList', list)
      dispatch('addVisitedList', list)
    },
    addVisitedView({ commit }, view) {
      commit('ADD_VISITED_VIEWS', view)
    },
    addCachedView({ commit }, view) {
      commit('ADD_CACHED_VIEW', view)
    },
    addVisitedList({ commit }, list) {
      commit('ADD_VISITED_LIST', list)
    },
    addCachedList({ commit }, list) {
      commit('ADD_CACHED_LIST', list)
    },
    delVisitedView({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_VISITED_VIEW', view)
        resolve([...state.visitedViews])
      })
    },
    delOthersViews({ commit, state }, view) {
      return new Promise((resolve) => {
        commit('DEL_OTHERS_VIEWS', view)
        resolve([...state.visitedViews])
      })
    },
    delCachedView({ commit, state }, view) {
      return new Promise(resolve => {
        commit('DEL_CACHED_VIEW', view)
        resolve([...state.cachedViews])
      })
    },
    delAllViews({ commit, state }) {
      return new Promise((resolve) => {
        commit('DEL_ALL_VIEWS')
        resolve([...state.visitedViews])
      })
    },
    delNextAllViews({ commit, state }, view) {
      
      return new Promise((resolve) => {
        commit('DEL_NEXT_ALL_VIEWS', view)
      })
    }
  }
}

export default tagsView
